import { Banco, IGerarRetorno } from "./types/Boletos";
import { ailos } from "@/banks/ailos";
import { bradesco } from "@/banks/bradesco";
import { sicredi } from "@/banks/sicredi";
import { bancoBrasil } from "@/banks/banco-brasil";
import { sicoob } from "@/banks/sicoob";

export function retorno({ banco, dados }: IGerarRetorno) {
  if (banco === Banco.AILOS) {
    return ailos.gerarRetorno({ banco, dados });
  }

  if (banco === Banco.BRADESCO) {
    return bradesco.gerarRetorno({ banco, dados });
  }

  if (banco === Banco.SICREDI) {
    return sicredi.gerarRetorno({ banco, dados });
  }

  if (banco === Banco.BANCO_BRASIL) {
    return bancoBrasil.gerarRetorno({ banco, dados });
  }

  if (banco === Banco.SICOOB) {
    return sicoob.gerarRetorno({ banco, dados });
  }
}
